import styled from 'styled-components';

export const DeleteShiftRadioButtonsWrapper = styled.div``;
